// @flow

import type {GetCheckedTextList} from '../typedef';

export const getCheckedTextList: GetCheckedTextList = (data, checkedIdsList) => {
    const areAllChildrenChecked = (children) => {
        if (!children || children.length === 0) {
            return false;
        }

        return children.every(child => {
            const isChecked = checkedIdsList.includes(child.id);
            const hasChildren = Boolean(child.children && child.children.length > 0);

            if (!hasChildren) {
                return isChecked;
            }

            return isChecked || areAllChildrenChecked(child.children);
        });
    };

    return data.reduce((acc, item) => {
        const isItemChecked = checkedIdsList.includes(item.id);
        const hasChildren = Boolean(item.children && item.children.length > 0);
        const caption = item.caption || '';

        if (isItemChecked) {
            acc.push(caption);

            return acc;
        }

        if (hasChildren && item.children && areAllChildrenChecked(item.children)) {
            acc.push(caption);

            return acc;
        }

        if (hasChildren && item.children) {
            return acc.concat(getCheckedTextList(item.children, checkedIdsList));
        }

        return acc;
    }, []);
}
